import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { Environment, OrbitControls } from '@react-three/drei';
import { Physics } from '@react-three/cannon';
import { EffectComposer, DepthOfField, Bloom, N8AO } from '@react-three/postprocessing';
import Player from './components/Player';
import Delhi from './components/Delhi';
import './index.css';

const App = () => {
  return (
    <div style={{ width: '100vw', height: '100vh', background: '#3a3f44' }}>
      {/* Cap DPR to 1.5 to save huge amounts of fill rate on mobile retina screens */}
      <Canvas shadows dpr={[1, 1.5]} camera={{ position: [0, 5, 10], fov: 60 }} gl={{ toneMappingExposure: 0.8 }}>
        {/* Vibrant Sunny Sky */}
        <color attach="background" args={['#87CEEB']} />
        {/* Very light, distant fog so it doesn't look completely flat, but not oppressive smog */}
        <fog attach="fog" args={['#87CEEB', 60, 200]} />
        
        <ambientLight intensity={0.6} color="#fff1e0" />
        
        {/* Main Sun Light with softer shadows */}
        <directionalLight
          castShadow
          position={[50, 100, 50]}
          intensity={1.2}
          color="#ffeedd"
          shadow-mapSize-width={2048}
          shadow-mapSize-height={2048}
          shadow-camera-far={200}
          shadow-camera-left={-100}
          shadow-camera-right={100}
          shadow-camera-top={100}
          shadow-camera-bottom={-100}
          shadow-bias={-0.001}
        />

        <Suspense fallback={null}>
          <OrbitControls 
            target={[0, 2, 0]} 
            maxPolarAngle={Math.PI / 2 + 0.1} 
            minDistance={2} 
            maxDistance={25} 
            enableDamping 
          />
          
          {/* Photorealistic HDRI from Poly Haven */}
          <Environment preset="city" background blur={0.1} />
          
          <Physics gravity={[0, -30, 0]}>
            <Player />
            <Delhi />
          </Physics>

          {/* Advanced Graphics Overhaul - Disabled multisampling for mobile performance */}
          <EffectComposer>
            <N8AO halfRes aoRadius={2} intensity={1.5} color="black" />
            <Bloom luminanceThreshold={1.2} luminanceSmoothing={0.9} height={300} intensity={1.5} />
          </EffectComposer>
        </Suspense>
      </Canvas>
    </div>
  );
};

export default App;
